import { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';

export const useRecentProjectTracker = () => {
	di(fetch);

	const isAnonymous = useIsAnonymous();
	const { data: project } = useProject();

	const projectKey = project?.key;

	useEffect(() => {
		if (isAnonymous || projectKey == null) return;

		const url = `/rest/api/latest/project/${encodeURIComponent(projectKey)}/tracking/recent`;
		fetch(url, {
			...getDefaultOptions(url),
			method: 'PUT',
		})
			.then((response) => {
				if (response.ok) {
					return response;
				}

				throw new Error(`Server didn't accept "${projectKey}", status code: ${response.status}`);
			})
			.catch((e) => {
				log.safeErrorWithoutCustomerData(
					'project-layout.use-recent-project-tracker',
					'There was a problem saving recent visited project',
					e,
				);
			});
	}, [isAnonymous, projectKey]);
};
